/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { AttributeValue } from '@msdyn365-commerce/retail-proxy';

/**
 * GetCmsListContent Input Action
 */
export class GetNewsDetailListTagsInput implements Msdyn365.IActionInput {
    // TODO: Construct the input needed to run the action
    constructor() {}

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `CMS_NEWS_TAGS`;
    public getCacheObjectType = () => 'CMS_NEWS_TAGS';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

// TODO: Create a data model here or import one to capture the response of the action
export interface IGetNewsDetailListTagsData {
    dataTags: AttributeValue[];
}

/**
 * TODO: Use this function to create the input required to make the action call
 */
const createInput = (args: Msdyn365.ICreateActionContext): Msdyn365.IActionInput => {
    return new GetNewsDetailListTagsInput();
};

/**
 * TODO: Use this function to call your action and process the results as needed
 */
async function action(input: GetNewsDetailListTagsInput, ctx: Msdyn365.IActionContext): Promise<IGetNewsDetailListTagsData | null> {
    const frontApiEndpoint = ctx.requestContext.app.config.cmsAPIEndpoint && ctx.requestContext.app.config.cmsAPIEndpoint;
    const requestUrl = `${frontApiEndpoint}/api/list/news-detail/tags`;
    const result = await Msdyn365.sendRequest<IGetNewsDetailListTagsData>(requestUrl, 'get')
        .then(response => {
            return response.data;
        })
        .catch(error => {
            ctx.trace('[GetCmsNewsDetailListTags] Failed to get list tags.');
            throw error;
        });
    return result;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IGetNewsDetailListTagsData>>action,
    // TODO: Give your data action a unique id
    id: 'GetCmsNewsDetailListTags',
    input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
